export default __webpack_public_path__ + "static/media/5.dd33901e.mp4";